import { createSlice, configureStore } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/dist/createAction";
import { ReceiptNF } from "../../../../domain/models/receipt-model";

type receiptsState = { data: ReceiptNF[] };

const initialState: receiptsState = {
  data: [],
};

const receiptsSlice = createSlice({
  name: "receipts",
  initialState,
  reducers: {
    saveBatch: (
      state,
      action: PayloadAction<{
        batch: string;
        nfNumber: string;
        nItem: string;
      }>
    ) => {
      const nf = state.data.find((nf) => nf.number === action.payload.nfNumber);
      if (nf) {
        const item = nf?.items.find(
          (item) => item.nItem === action.payload.nItem
        );
        if (item) {
          item.batch = action.payload.batch;
        }
      }
    },
    saveNf: (state, action: PayloadAction<{ nf: ReceiptNF }>) => {
      state.data.push(action.payload.nf);
    },
    updateNfs: (state, action: PayloadAction<{ nfs: ReceiptNF[] }>) => {
      state.data = action.payload.nfs;
    },
    removeNf: (state, action: PayloadAction<{ nf: ReceiptNF }>) => {
      state.data = state.data.filter(
        (item) => item.reference !== action.payload.nf.reference
      );
    },
    reset: (state) => {
      state.data = [];
    },
    toggleBatchOption: (
      state,
      action: PayloadAction<{ nfNumber: string; nItem: string; value: boolean }>
    ) => {
      const nf = state.data.find((nf) => nf.number === action.payload.nfNumber);
      if (nf) {
        const item = nf?.items.find(
          (item) => item.nItem === action.payload.nItem
        );
        if (item) {
          item.insertBatchLater = action.payload.value;
        }
      }
    },
  },
});

export const store = configureStore({
  reducer: receiptsSlice.reducer,
});
export type ReceiptState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const receiptsActions = receiptsSlice.actions;
